module.exports = __webpack_public_path__ + "media/images/author-404-d4b152430262468e82f89b757ccaf18c.jpg";